<script lang="ts">
  import { getCategories, getInstitutions, getPeople } from '../lib/storage.js';
  import FilterControls from './filters/FilterControls.svelte';
  import type { FilterValues } from '../types/common';
  import { NON_BUDGETABLE_CATEGORIES } from '../lib/constants.js';

  let {
    filters = $bindable({} as FilterValues),
    onFilterChange = () => {},
    isExpanded = $bindable(true),
    autoInitializeCategories = true
  }: {
    filters?: FilterValues;
    onFilterChange?: () => void;
    isExpanded?: boolean;
    autoInitializeCategories?: boolean;
  } = $props();

  let categories = $state<string[]>([]);
  let institutions = $state<string[]>([]);
  let people = $state<string[]>([]);

  $effect(() => {
    loadCategories();
    loadInstitutions();
    loadPeople();
  });

  async function loadCategories(): Promise<void> {
    categories = await getCategories();

    // Initialize categories if empty
    if (filters.category.length === 0 && autoInitializeCategories) {
      // For budgets page: exclude non-budgetable categories
      filters.category = categories.filter(cat => !NON_BUDGETABLE_CATEGORIES.includes(cat));
      onFilterChange();
    }
    // For overview page (autoInitializeCategories=false): leave empty to show all transactions
  }

  async function loadInstitutions(): Promise<void> {
    institutions = await getInstitutions();
  }

  async function loadPeople(): Promise<void> {
    people = await getPeople();
  }

  function handleChange(): void {
    onFilterChange();
  }
</script>

{#if isExpanded}
  <div class="filters-inline">
    <FilterControls
      bind:filters
      {categories}
      {institutions}
      {people}
      onChange={handleChange}
    />
  </div>
{/if}

<style lang="scss">
  .filters-inline {
    background: var(--color-background);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg);
    padding: var(--spacing-md) var(--spacing-lg);
    margin-bottom: var(--spacing-md);
    animation: slideDown var(--transition-fast);
    transition: all var(--transition-fast);
  }
</style>
